export function truncate(text: string, maxLength: number = 100): string {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength).trim() + "…" : text;
}

export function formatEmail(email: string): string {
  if (!email) return "";
  const [localPart, domain] = email.split("@");
  if (!domain) return email;

  if (localPart.length <= 8) return email;
  return `${localPart.slice(0, 5)}...${localPart.slice(-3)}@${domain}`;
}
